// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cellMuted[data-v-bba1923e]{color:var(--link-ink-secondary)}.stylePreviewImg[data-v-bba1923e]{width:72px;max-width:100%;border-radius:8px;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
module.exports = exports;
